var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7914 12.6082C21.0355 12.3989 21.1575 12.2943 21.2023 12.1698C21.2415 12.0605 21.2415 11.941 21.2023 11.8317C21.1575 11.7072 21.0355 11.6026 20.7914 11.3934L12.3206 4.13275C11.9004 3.77256 11.6903 3.59246 11.5124 3.58804C11.3578 3.58421 11.2101 3.65213 11.1124 3.77201C11 3.90995 11 4.18668 11 4.74016V9.03541C8.86532 9.40887 6.91159 10.4905 5.45971 12.1146C3.87682 13.8853 3.00123 16.1767 3 18.5517V19.1637C4.04934 17.8996 5.35951 16.8773 6.84076 16.1667C8.1467 15.5402 9.55842 15.1691 11 15.0713V19.2614C11 19.8149 11 20.0916 11.1124 20.2296C11.2101 20.3494 11.3578 20.4174 11.5124 20.4135C11.6903 20.4091 11.9004 20.229 12.3206 19.8688L20.7914 12.6082Z",
    stroke: "#D66700",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkShare);
export default __webpack_public_path__ + "static/media/pink-share.aa38476d509e8ea8a686c9027bc6e09c.svg";
export { ForwardRef as ReactComponent };